import { downloadCsv } from "../../../../utils/csvExport.js";
import { csvField, filenameStamp } from "./csvHelpers.js";
import type { InvalidTestimonialStatusRow } from "./parseTestimonialStatusCsv.js";
import type { TestimonialStatusBatchTotals } from "./useTestimonialStatusBatch.js";

export const INVALID_ROWS_HEADERS = ["line", "testimonial_id", "status", "reason"] as const;

export const REPORT_HEADERS = ["testimonial_id", "outcome"] as const;

export const DUPLICATE_REASON = "testimonial_id appears more than once";

export function buildInvalidRowsCsv(
  invalid: InvalidTestimonialStatusRow[],
  duplicates: string[],
): string {
  const lines: string[] = [INVALID_ROWS_HEADERS.join(",")];
  for (const row of invalid) {
    lines.push([row.line, row.testimonialId, row.status, row.reason].map(csvField).join(","));
  }
  for (const testimonialId of duplicates) {
    lines.push([null, testimonialId, null, DUPLICATE_REASON].map(csvField).join(","));
  }
  return `${lines.join("\n")}\n`;
}

export function buildReportCsv(totals: TestimonialStatusBatchTotals): string {
  const lines: string[] = [REPORT_HEADERS.join(",")];
  for (const testimonialId of totals.notFoundIds) {
    lines.push([testimonialId, "NOT_FOUND"].map(csvField).join(","));
  }
  for (const testimonialId of totals.withdrawnSkippedIds) {
    lines.push([testimonialId, "WITHDRAWN_SKIPPED"].map(csvField).join(","));
  }
  for (const testimonialId of totals.notSuspendableIds) {
    lines.push([testimonialId, "NOT_SUSPENDABLE"].map(csvField).join(","));
  }
  return `${lines.join("\n")}\n`;
}

export function invalidRowsFilename(now: Date): string {
  return `testimonial-status-invalid-rows-${filenameStamp(now)}.csv`;
}

export function reportFilename(dryRun: boolean, now: Date): string {
  return `testimonial-status-${dryRun ? "dry-run" : "applied"}-${filenameStamp(now)}.csv`;
}

export function downloadInvalidRowsCsv(
  invalid: InvalidTestimonialStatusRow[],
  duplicates: string[],
  at: Date,
): void {
  downloadCsv(buildInvalidRowsCsv(invalid, duplicates), invalidRowsFilename(at));
}

export function downloadReportCsv(
  totals: TestimonialStatusBatchTotals,
  dryRun: boolean,
  at: Date,
): void {
  downloadCsv(buildReportCsv(totals), reportFilename(dryRun, at));
}
